export const buildRoute = (
  orgDomain: string | undefined,
  connectionIndex: string | number,
  path?: string
) => {
  let route = '';
  if (orgDomain) {
    route += `/o/${orgDomain}/`;
  } else {
    route += `/u/`;
  }

  if (connectionIndex !== '') {
    // add the connection index
    route += `${connectionIndex}/`;
  } else if (orgDomain) {
    // if there is no connection, return to the org dashboard
    return route;
  } else {
    // if there is no connection, return to the new user landing
    return '/';
  }

  if (path) {
    // add any additional paths
    route += path;
  }

  return route;
};

export const buildDashboardRoute = (
  orgDomain: string | undefined,
  path = '',
  connectionIndex: string | number = ''
) => {
  if (!orgDomain) {
    return '/';
  }

  let route = `/o/${orgDomain}/`;
  if (path) {
    // add any additional paths
    route += `${path}/`;
  }

  if (connectionIndex !== '') {
    // add the connection index
    route += `${connectionIndex}/`;
  }
  return route;
};
